import { useList, useDetail, useCreate, useUpdate, useDelete, fetchApi } from "@inmagik/react-crud"
import { Tag } from "../types"
import { API_URL } from "../constants"
import { useCallback } from "react"
import { normalizeParams } from "@inmagik/react-crud/dist/crud/utils"
import { useAuth } from "../auth"

export function useTagsList(
  params: // accept also list of ids
  Record<string, string | number | Array<number>> = {},
  enabled = true
) {
  return useList<Tag>(`${API_URL}/admin/tags`, {
    query: params,
    reactQuery: {
      enabled: enabled,
      queryKey: ["tags", params],
    },
  })
}

export function useTag(id: number | undefined) {
  return useDetail<Tag>(`${API_URL}/admin/tags`, id?.toString())
}

export function useTagLazy() {
  const auth = useAuth()
  return useCallback((id: number) => {
    return fetchApi(`${API_URL}/admin/tags/${id}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<Tag>
  }, [])
}

export function useTagsLazy() {
  const auth = useAuth()
  return useCallback((params: Record<string, string | number | Array<number>>) => {
    const qs = normalizeParams(params).toString()
    return fetchApi(`${API_URL}/admin/tags?${qs}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<{ results: Tag[] }>
  }, [])
}

export function useTagCreate() {
  return useCreate<Tag>(`${API_URL}/admin/tags`)
}

export function useTagUpdate() {
  return useUpdate<Tag>(`${API_URL}/admin/tags`)
}

export function useTagDelete() {
  return useDelete(`${API_URL}/admin/tags`)
}
